// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"77d0c3b4","796":"10210848"}[chunkId] + ".chunk.js";
};